function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M66.57 37.969l-60.175.468v.259l-2.822-.072c-.133-.213-.323-.394-.542-.473l-.425-.155c-.111-.312-.337-.613-.604-.754l-1.325-.701c-.372-.197-.677-.014-.677.408v6.476c0 .421.305.605.677.408l1.325-.701c.266-.141.493-.441.604-.754l.425-.155c.219-.08.409-.259.542-.473l2.822-.072v.259l60.176.468c4.954 0 8.969 4.016 8.969 8.97s-4.015 8.97-8.969 8.97H29.854a8.97 8.97 0 01-8.97-8.97c0-3.535 2.049-6.728 5.02-8.273l-6.55-.051a13.337 13.337 0 00-2.906 8.324c0 7.404 6.001 13.405 13.405 13.405H66.57c7.402 0 13.404-6.001 13.404-13.405S73.973 37.969 66.57 37.969z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M98.652 23.776c-1.578 14.193-20.501 14.193-20.501 14.193h-6.305a14.465 14.465 0 015.992 4.435h.312s18.923 0 20.501 14.192c0 0 .031.402.69.402V23.375c-.657 0-.689.401-.689.401z"
});

function SvgBrass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
}

export default SvgBrass;